export const TEST_NOTIFICATIONS_STORAGE_KEY = 'testNotifications'

export function getTestNotificationsFromStorage(): boolean {
  try {
    const item = window.localStorage.getItem(TEST_NOTIFICATIONS_STORAGE_KEY)
    if (item === null) return false
    return JSON.parse(item) === true
  } catch {
    return false
  }
}
